import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _SidebarEditNavigationMenuCategoriesModal;
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { concat, fn, get } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import didInsert from "@ember/render-modifiers/modifiers/did-insert";
import { service } from "@ember/service";
import { TrackedSet } from "@ember-compat/tracked-built-ins";
import { gt, has, includes, not } from "truth-helpers";
import EditNavigationMenuModal from "discourse/components/sidebar/edit-navigation-menu/modal";
import borderColor from "discourse/helpers/border-color";
import categoryBadge from "discourse/helpers/category-badge";
import dirSpan from "discourse/helpers/dir-span";
import loadingSpinner from "discourse/helpers/loading-spinner";
import { popupAjaxError } from "discourse/lib/ajax-error";
import Category from "discourse/models/category";
import { INPUT_DELAY } from "discourse-common/config/environment";
import i18n from "discourse-common/helpers/i18n";
import discourseDebounce from "discourse-common/lib/debounce";
// Given a list, break into chunks starting a new chunk whenever the predicate
// is true for an element.
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
function splitWhere(elements1, f1) {
  return elements1.reduce((acc1, el1, i1) => {
    if (i1 === 0 || f1(el1)) {
      acc1.push([]);
    }
    acc1[acc1.length - 1].push(el1);
    return acc1;
  }, []);
}
function findAncestors(categories1) {
  let categoriesToCheck1 = categories1;
  const ancestors1 = [];
  for (let i1 = 0; i1 < 3; i1++) {
    categoriesToCheck1 = categoriesToCheck1.map(c1 => Category.findById(c1.parent_category_id)).filter(Boolean).uniqBy(c1 => c1.id);
    ancestors1.push(...categoriesToCheck1);
  }
  return ancestors1;
}
let SidebarEditNavigationMenuCategoriesModal = (_class = (_SidebarEditNavigationMenuCategoriesModal = class SidebarEditNavigationMenuCategoriesModal extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "site", _descriptor2, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor3, this);
    _initializerDefineProperty(this, "initialLoad", _descriptor4, this);
    _initializerDefineProperty(this, "filteredCategoriesGroupings", _descriptor5, this);
    _initializerDefineProperty(this, "filteredCategoryIds", _descriptor6, this);
    _initializerDefineProperty(this, "selectedSidebarCategoryIds", _descriptor7, this);
    _defineProperty(this, "hasMorePages", void 0);
    _defineProperty(this, "loadedFilter", void 0);
    _defineProperty(this, "loadedMode", void 0);
    _defineProperty(this, "loadedPage", void 0);
    _defineProperty(this, "processing", false);
    _defineProperty(this, "requestedFilter", void 0);
    _defineProperty(this, "requestedMode", void 0);
    _defineProperty(this, "saving", false);
    _defineProperty(this, "observer", new IntersectionObserver(_ref => {
      let [entry1] = _ref;
      if (entry1.isIntersecting) {
        this.observer.disconnect();
        this.loadMore();
      }
    }, {
      threshold: 1.0
    }));
    this.setFilterAndMode("", "everything");
  }
  setFilteredCategories(categories1) {
    this.filteredCategories = categories1;
    const ancestors1 = findAncestors(categories1);
    const allCategories1 = categories1.concat(ancestors1).uniqBy(c1 => c1.id);
    this.filteredCategoriesGroupings = splitWhere(Category.sortCategories(allCategories1), category1 => category1.parent_category_id === undefined);
    this.filteredCategoryIds = categories1.map(c1 => c1.id);
  }
  concatFilteredCategories(categories1) {
    this.setFilteredCategories(this.filteredCategories.concat(categories1));
  }
  setFetchedCategories(mode1, categories1) {
    this.setFilteredCategories(this.applyMode(mode1, categories1));
  }
  concatFetchedCategories(mode1, categories1) {
    this.concatFilteredCategories(this.applyMode(mode1, categories1));
  }
  applyMode(mode1, categories1) {
    return categories1.filter(c1 => {
      switch (mode1) {
        case "everything":
          return true;
        case "only-selected":
          return this.selectedSidebarCategoryIds.has(c1.id);
        case "only-unselected":
          return !this.selectedSidebarCategoryIds.has(c1.id);
      }
    });
  }
  didInsert(element1) {
    this.observer.disconnect();
    this.observer.observe(element1);
  }
  async searchCategories(filter1, mode1) {
    if (filter1 === "" && mode1 === "only-selected") {
      this.setFilteredCategories(await Category.asyncFindByIds([...this.selectedSidebarCategoryIds]));
      this.loadedPage = null;
      this.hasMorePages = false;
    } else {
      const {
        categories: categories1
      } = await Category.asyncSearch(filter1, {
        includeAncestors: true,
        includeUncategorized: false
      });
      this.setFetchedCategories(mode1, categories1);
      this.loadedPage = 1;
      this.hasMorePages = true;
    }
  }
  async setFilterAndMode(newFilter1, newMode1) {
    this.requestedFilter = newFilter1;
    this.requestedMode = newMode1;
    if (!this.processing) {
      this.processing = true;
      try {
        while (this.loadedFilter !== this.requestedFilter || this.loadedMode !== this.requestedMode) {
          const filter1 = this.requestedFilter;
          const mode1 = this.requestedMode;
          await this.searchCategories(filter1, mode1);
          this.loadedFilter = filter1;
          this.loadedMode = mode1;
          this.initialLoad = false;
        }
      } finally {
        this.processing = false;
      }
    }
  }
  async loadMore() {
    if (!this.processing && this.hasMorePages) {
      this.processing = true;
      try {
        const page1 = this.loadedPage + 1;
        const {
          categories: categories1
        } = await Category.asyncSearch(this.requestedFilter, {
          includeAncestors: true,
          includeUncategorized: false,
          page: page1
        });
        this.loadedPage = page1;
        if (categories1.length === 0) {
          this.hasMorePages = false;
        } else {
          this.concatFetchedCategories(this.requestedMode, categories1);
        }
      } finally {
        this.processing = false;
      }
      if (this.loadedFilter !== this.requestedFilter || this.loadedMode !== this.requestedMode) {
        await this.setFilterAndMode(this.requestedFilter, this.requestedMode);
      }
    }
  }
  debouncedSetFilterAndMode(filter1, mode1) {
    discourseDebounce(this, this.setFilterAndMode, filter1, mode1, INPUT_DELAY);
  }
  resetFilter() {
    this.debouncedSetFilterAndMode(this.requestedFilter, "everything");
  }
  filterSelected() {
    this.debouncedSetFilterAndMode(this.requestedFilter, "only-selected");
  }
  filterUnselected() {
    this.debouncedSetFilterAndMode(this.requestedFilter, "only-unselected");
  }
  onFilterInput(filter1) {
    this.debouncedSetFilterAndMode(filter1.toLowerCase().trim(), this.requestedMode);
  }
  deselectAll() {
    this.selectedSidebarCategoryIds.clear();
  }
  toggleCategory(categoryId1) {
    if (this.selectedSidebarCategoryIds.has(categoryId1)) {
      this.selectedSidebarCategoryIds.delete(categoryId1);
    } else {
      this.selectedSidebarCategoryIds.add(categoryId1);
    }
  }
  resetToDefaults() {
    this.selectedSidebarCategoryIds = new TrackedSet(this.siteSettings.default_navigation_menu_categories.split("|").map(id1 => parseInt(id1, 10)));
  }
  async save() {
    this.saving = true;
    const initialSidebarCategoryIds1 = this.currentUser.sidebar_category_ids;
    this.currentUser.set("sidebar_category_ids", [...this.selectedSidebarCategoryIds]);
    try {
      await this.currentUser.save(["sidebar_category_ids"]);
      this.args.closeModal();
    } catch (error1) {
      this.currentUser.set("sidebar_category_ids", initialSidebarCategoryIds1);
      popupAjaxError(error1);
    } finally {
      this.saving = false;
    }
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <EditNavigationMenuModal
      @title="sidebar.categories_form_modal.title"
      @disableSaveButton={{this.saving}}
      @save={{this.save}}
      @showResetDefaultsButton={{gt
        this.siteSettings.default_navigation_menu_categories.length
        0
      }}
      @resetToDefaults={{this.resetToDefaults}}
      @deselectAll={{this.deselectAll}}
      @deselectAllText={{i18n "sidebar.categories_form_modal.subtitle.text"}}
      @inputFilterPlaceholder={{i18n
        "sidebar.categories_form_modal.filter_placeholder"
      }}
      @onFilterInput={{this.onFilterInput}}
      @resetFilter={{this.resetFilter}}
      @filterSelected={{this.filterSelected}}
      @filterUnselected={{this.filterUnselected}}
      @closeModal={{@closeModal}}
      class="sidebar__edit-navigation-menu__categories-modal"
    >
      <form class="sidebar-categories-form">
        {{#if this.initialLoad}}
          <div class="sidebar-categories-form__loading">
            {{loadingSpinner size="small"}}
          </div>
        {{else}}
          {{#each this.filteredCategoriesGroupings as |categories|}}
            <div
              {{didInsert this.didInsert}}
              style={{borderColor (get categories "0.color") "left"}}
              class="sidebar-categories-form__row"
            >
              {{#each categories as |category|}}
                <div
                  data-category-id={{category.id}}
                  data-category-level={{category.level}}
                  class="sidebar-categories-form__category-row"
                >
                  <label
                    for={{concat
                      "sidebar-categories-form__input--"
                      category.id
                    }}
                    class="sidebar-categories-form__category-label"
                  >
                    <div class="sidebar-categories-form__category-wrapper">
                      <div class="sidebar-categories-form__category-badge">
                        {{categoryBadge category}}
                      </div>

                      {{#unless category.parentCategory}}
                        <div
                          class="sidebar-categories-form__category-description"
                        >
                          {{dirSpan
                            category.description_excerpt
                            htmlSafe="true"
                          }}
                        </div>
                      {{/unless}}
                    </div>

                    <input
                      {{on "click" (fn this.toggleCategory category.id)}}
                      type="checkbox"
                      checked={{has
                        this.selectedSidebarCategoryIds
                        category.id
                      }}
                      disabled={{not
                        (includes this.filteredCategoryIds category.id)
                      }}
                      id={{concat
                        "sidebar-categories-form__input--"
                        category.id
                      }}
                      class="sidebar-categories-form__input"
                    />
                  </label>
                </div>
              {{/each}}
            </div>
          {{else}}
            <div class="sidebar-categories-form__no-categories">
              {{i18n "sidebar.categories_form_modal.no_categories"}}
            </div>
          {{/each}}
        {{/if}}
      </form>
    </EditNavigationMenuModal>
  
*/
{
  "id": "XcFT8s3W",
  "block": "[[[1,\"\\n    \"],[8,[32,0],[[24,0,\"sidebar__edit-navigation-menu__categories-modal\"]],[[\"@title\",\"@disableSaveButton\",\"@save\",\"@showResetDefaultsButton\",\"@resetToDefaults\",\"@deselectAll\",\"@deselectAllText\",\"@inputFilterPlaceholder\",\"@onFilterInput\",\"@resetFilter\",\"@filterSelected\",\"@filterUnselected\",\"@closeModal\"],[\"sidebar.categories_form_modal.title\",[30,0,[\"saving\"]],[30,0,[\"save\"]],[28,[32,1],[[30,0,[\"siteSettings\",\"default_navigation_menu_categories\",\"length\"]],0],null],[30,0,[\"resetToDefaults\"]],[30,0,[\"deselectAll\"]],[28,[32,2],[\"sidebar.categories_form_modal.subtitle.text\"],null],[28,[32,2],[\"sidebar.categories_form_modal.filter_placeholder\"],null],[30,0,[\"onFilterInput\"]],[30,0,[\"resetFilter\"]],[30,0,[\"filterSelected\"]],[30,0,[\"filterUnselected\"]],[30,1]]],[[\"default\"],[[[[1,\"\\n      \"],[10,\"form\"],[14,0,\"sidebar-categories-form\"],[12],[1,\"\\n\"],[41,[30,0,[\"initialLoad\"]],[[[1,\"          \"],[10,0],[14,0,\"sidebar-categories-form__loading\"],[12],[1,\"\\n            \"],[1,[28,[32,3],null,[[\"size\"],[\"small\"]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[42,[28,[31,2],[[28,[31,2],[[30,0,[\"filteredCategoriesGroupings\"]]],null]],null],null,[[[1,\"            \"],[11,0],[16,5,[28,[32,4],[[28,[32,5],[[30,2],\"0.color\"],null],\"left\"],null]],[24,0,\"sidebar-categories-form__row\"],[4,[32,6],[[30,0,[\"didInsert\"]]],null],[12],[1,\"\\n\"],[42,[28,[31,2],[[28,[31,2],[[30,2]],null]],null],null,[[[1,\"                \"],[10,0],[15,\"data-category-id\",[30,3,[\"id\"]]],[15,\"data-category-level\",[30,3,[\"level\"]]],[14,0,\"sidebar-categories-form__category-row\"],[12],[1,\"\\n                  \"],[10,\"label\"],[15,\"for\",[28,[32,7],[\"sidebar-categories-form__input--\",[30,3,[\"id\"]]],null]],[14,0,\"sidebar-categories-form__category-label\"],[12],[1,\"\\n                    \"],[10,0],[14,0,\"sidebar-categories-form__category-wrapper\"],[12],[1,\"\\n                      \"],[10,0],[14,0,\"sidebar-categories-form__category-badge\"],[12],[1,\"\\n                        \"],[1,[28,[32,8],[[30,3]],null]],[1,\"\\n                      \"],[13],[1,\"\\n\\n\"],[41,[51,[30,3,[\"parentCategory\"]]],[[[1,\"                        \"],[10,0],[14,0,\"sidebar-categories-form__category-description\"],[12],[1,\"\\n                          \"],[1,[28,[32,9],[[30,3,[\"description_excerpt\"]]],[[\"htmlSafe\"],[\"true\"]]]],[1,\"\\n                        \"],[13],[1,\"\\n\"]],[]],null],[1,\"                    \"],[13],[1,\"\\n\\n                    \"],[11,\"input\"],[16,\"checked\",[28,[32,10],[[30,0,[\"selectedSidebarCategoryIds\"]],[30,3,[\"id\"]]],null]],[16,\"disabled\",[28,[32,11],[[28,[32,12],[[30,0,[\"filteredCategoryIds\"]],[30,3,[\"id\"]]],null]],null]],[16,1,[28,[32,7],[\"sidebar-categories-form__input--\",[30,3,[\"id\"]]],null]],[24,0,\"sidebar-categories-form__input\"],[24,4,\"checkbox\"],[4,[32,13],[\"click\",[28,[32,14],[[30,0,[\"toggleCategory\"]],[30,3,[\"id\"]]],null]],null],[12],[13],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n\"]],[3]],null],[1,\"            \"],[13],[1,\"\\n\"]],[2]],[[[1,\"            \"],[10,0],[14,0,\"sidebar-categories-form__no-categories\"],[12],[1,\"\\n              \"],[1,[28,[32,2],[\"sidebar.categories_form_modal.no_categories\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]]]],[]]],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[\"@closeModal\",\"categories\",\"category\"],false,[\"if\",\"each\",\"-track-array\",\"unless\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/sidebar/edit-navigation-menu/categories-modal.js",
  "scope": () => [EditNavigationMenuModal, gt, i18n, loadingSpinner, borderColor, get, didInsert, concat, categoryBadge, dirSpan, has, not, includes, on, fn],
  "isStrictMode": true
}), _SidebarEditNavigationMenuCategoriesModal), _SidebarEditNavigationMenuCategoriesModal), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "initialLoad", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "filteredCategoriesGroupings", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "filteredCategoryIds", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "selectedSidebarCategoryIds", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new TrackedSet([...this.currentUser.sidebar_category_ids]);
  }
}), _applyDecoratedDescriptor(_class.prototype, "didInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetFilter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filterSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "filterSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filterUnselected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "filterUnselected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onFilterInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onFilterInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deselectAll", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deselectAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCategory", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCategory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetToDefaults", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetToDefaults"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [action], Object.getOwnPropertyDescriptor(_class.prototype, "save"), _class.prototype)), _class);
export { SidebarEditNavigationMenuCategoriesModal as default };